import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class CustomerRepository<
    CustomerModel
> extends RepositoryBase<CustomerModel> {
    public constructor() {
        super('customer');
    }
}
